import './styles/global.scss'
import './styles/absa-theme.css'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import { MsalProvider } from '@azure/msal-react'
import { ThemeProvider } from '@emotion/react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { Toaster } from 'components/core-v2'
import { setAutoFreeze } from 'immer'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Provider } from 'react-redux'
import { useLogRocket } from 'utilities/hooks/useLogRocket'

import { msalInstance } from '@/msalInstance'

import { useGetStatusOnlineQuery } from './api'
import { Router } from './routing/Router'
import { store } from './state/store'
import { absaTheme, muiAbsaTheme } from './styles/themes/absa'
import { suppressKnownErrorsAndWarnings } from './utilities/errors'
import { useUser } from './utilities/hooks/useUser'

setAutoFreeze(false)
if (import.meta.env.MODE === 'development') suppressKnownErrorsAndWarnings()

const App = () => {
  useGetStatusOnlineQuery()
  useUser()
  useLogRocket()
  return <Router />
}

const WrappedApp = () => (
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_KEY}>
        <MuiThemeProvider theme={muiAbsaTheme}>
          <ThemeProvider theme={absaTheme}>
            <Provider store={store}>
              <Toaster />
              <App />
            </Provider>
          </ThemeProvider>
        </MuiThemeProvider>
      </GoogleReCaptchaProvider>
    </MsalProvider>
  </StrictMode>
)

const container = document.getElementById('app') as HTMLElement
const root = createRoot(container)

const startApp = async () => {
  if (import.meta.env.MODE === 'development' && import.meta.env.VITE_ENABLE_MOCKING === 'true') {
    const { worker } = await import('@/__mocks__/msw/browser.js')
    await worker.start()
  }

  root.render(<WrappedApp />)
}

startApp()
